import { lazy } from 'react';

const RELOAD_KEY = 'vroom-panel:chunk-reload';

function isChunkLoadError(error) {
  const message = `${error?.name || ''} ${error?.message || ''}`;
  return /ChunkLoadError|Loading (?:CSS )?chunk \d+ failed|Failed to fetch dynamically imported module/i.test(message);
}

export default function lazyWithReload(importer) {
  return lazy(async () => {
    try {
      const module = await importer();
      sessionStorage.removeItem(RELOAD_KEY);
      return module;
    } catch (error) {
      const reloadTarget = window.location.href;
      if (isChunkLoadError(error) && sessionStorage.getItem(RELOAD_KEY) !== reloadTarget) {
        sessionStorage.setItem(RELOAD_KEY, reloadTarget);
        window.location.reload();
        return new Promise(() => {});
      }
      throw error;
    }
  });
}

export { isChunkLoadError, RELOAD_KEY };
